import { Icon } from '@iconify-icon/solid';
import { TextFieldRoot, TextFieldLabel, TextField } from "@/components/shadcn/textfield";

export function HeaderSearch(props) {
  return (
    <form class="w-[300px] me-2">
      <div class="relative m-0">
        <Icon icon="lucide:search" class="text-muted-foreground absolute left-2.5 top-2.5 h-4 w-4" />
        <TextFieldRoot class="w-full m-0 space-y-0">
          <TextFieldLabel class='sr-only'>Search</TextFieldLabel>
          <TextField
            class="bg-background w-full appearance-none pl-8 w-full mt-0"
            placeholder='Search'
            type='search'
            autoCapitalize="none"
            autocorrect="off"
            disabled={props.loading}
          />
        </TextFieldRoot>
      </div>
    </form>
  );
}